import {useQuery} from '@tanstack/react-query';
import {ConversationMessage} from '@/types/conversationMessage';
import contentSubmissionVersionMessagesFetchers from '@/api/fetchers/contentSubmissionVersionMessages';

export const CONTENT_SUBMISSION_VERSION_MESSAGES_QUERY_KEY =
  'contentSubmissionVersionMessages';

function useContentSubmissionVersionMessages(versionId: string | null) {
  return useQuery<ConversationMessage[]>({
    queryKey: [CONTENT_SUBMISSION_VERSION_MESSAGES_QUERY_KEY, versionId],
    queryFn: () => contentSubmissionVersionMessagesFetchers.list(versionId!),
    enabled: !!versionId,
    staleTime: 30 * 1000,
    refetchOnWindowFocus: true,
  });
}

export default useContentSubmissionVersionMessages;
